module.exports = __webpack_public_path__ + "img/dictionary-white.70770341.svg";